import { makeStyles, createStyles } from "@mui/styles";
import customColors from "../../styles/coreStyles/ColorPalette";
import customFonts from "../../styles/coreStyles/Fonts";

const SendBookingRequestsStyle = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: "1rem",
      borderRadius: "8px",
    },
    titlesBoxStyle: {
      marginBottom: "1rem",
      color: customColors.groupBlue,
    },
    dropdownGrid: {
      width: "100%",
    },
    typographyFirst: {
      fontFamily: customFonts.boldFont,
      color: customColors.groupBlue,
    },
    typographySecond: {
      fontFamily: customFonts.regularFont,
      color: customColors.groupBlue,
    },
    formControl: {
      width: "100%",
    },
    inputLabelAndMenuItems: {
      fontFamily: customFonts.regularFont,
      color: customColors.groupBlue,
    },
    textField: {
      width: "100%",
      "& label": {
        fontFamily: customFonts.regularFont,
        color: customColors.groupBlue,
      },
      marginBottom: "0.5rem",
    },
    actionButtonGrid: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "1rem",
    },
    buttons: {
      margin: "0.5rem",
    },
  })
);

export default SendBookingRequestsStyle;
